import React from "react";
import PAS from "../../components/Form/PAS/PAS.js";

const PAS_View = () => {
  return (
    <div>
      <PAS />
    </div>
  );
};

export default PAS_View;
